import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

/*
vue 鼠标事件控制台警告:
Added non-passive event listener to a scroll-blocking 'mousewheel' event. Consider marking event handler as 'passive' to make the page more responsive
解决此问题，引入下面的插件
安装命令：npm i default-passive-events -S
*/
import 'default-passive-events'
// 引入Lodash，Lodash 通过降低 array、number、objects、string 等等的使用难度从而让 JavaScript 变得更简单。
import _ from 'lodash'
import moment from 'moment'

// 用于ajax请求
import axios from 'axios'
// 用于ajax请求时，格式化数据
import qs from 'qs'
// ElementUI前端框架
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/iconfonts/iconfont.css'
import '@/assets/css/core.css'

// 引入echarts
// import echarts from 'echarts'

// 自定义函数库，用于判断当前用户的“活跃度”-----是否在操作
import checkActive from './common/checkActive.js'
import funHelper from './common/funHelper.js'
// 解决这个警告：export 'default' (imported as 'regionHelper') was not found in
// 可通过下面注释的代码。具体原因，还需要继续查资料。
// 网络查询的资料显示是：ES6 编译器识别问题。感觉这个原因似乎不全面
// import * as regionHelper from './common/regionHelper.js'
import regionHelper from './common/regionHelper.js'
import baseApis from './views/modules/base.apis.js'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
// 获取 当前 年份-月份
  Vue.prototype.$GetNowMonth = function () {
    var data = new Date()
    var month = data.getMonth() < 10 ? '0' + (data.getMonth() + 1) : data.getMonth() + 1
    var value = data.getFullYear() + '-' + month
    return value
  },

  // 获取当前 年月日
  Vue.prototype.$GetNowDate = function () {
    var data = new Date()
    var month = data.getMonth() < 10 ? '0' + (data.getMonth() + 1) : data.getMonth() + 1
    var date = data.getDate() < 10 ? '0' + data.getDate() : data.getDate()
    var hour = data.getHours < 10 ? '0' + data.getHours() : data.getHours()
    var minute = data.getMinutes < 10 ? '0' + data.getMinutes : data.getMinutes()
    var second = data.getSeconds < 10 ? '0' + data.getSeconds : data.getSeconds()
    var value = data.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    return value
  },

  // 获取 当前年月日 时分秒
  Vue.prototype.$GetNowDateTime = function () {
    var data = new Date()
    var month = data.getMonth() < 10 ? '0' + (data.getMonth() + 1) : data.getMonth() + 1
    var date = data.getDate() < 10 ? '0' + data.getDate() : data.getDate()
    var hour = data.getHours < 10 ? '0' + data.getHours() : data.getHours()
    var minute = data.getMinutes < 10 ? '0' + data.getMinutes : data.getMinutes()
    var second = data.getSeconds < 10 ? '0' + data.getSeconds : data.getSeconds()
    var value = data.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    return value
  },

  Vue.prototype.$exportExcel = function (dom, name) {
    let tabDOM = XLSX.utils.table_to_book(document.querySelector(dom));
    let wbout = XLSX.write(tabDOM, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'array'
    });
    try {
      FileSaver.saveAs(new Blob([wbout], {
        type: 'application/octet-stream'
      }), name);
    } catch (e) {
      if (typeof console !== 'undefined') {
        console.log(e, wbout)
      }
    }
    return wbout
  }
// import CKEditor from 'ckeditor4-vue'

Vue.prototype.$_ = _
Vue.prototype.$moment = moment
Vue.prototype.$http = axios
Vue.prototype.$qs = qs

// 定义全局引用，后面代码中，可以通过this.$echarts对echarts进行调用
// Vue.prototype.$echarts = echarts

Vue.use(ElementUI)
// Vue.use(CKEditor)

Vue.config.productionTip = false

// 设置该项，发起ajax请求的时候，才能携带session信息
// 但服务端的Access-Control-Allow-Origin不能为*
axios.defaults.withCredentials = true

// 定义全局的判断用户活跃度的方法
Vue.prototype.$chk = checkActive
Vue.prototype.$fun = funHelper
Vue.prototype.$region = regionHelper
/*
定义全局的退出方法，退出时清空sessionStorage
*/
Vue.prototype.logout = () => {
  // 清除指定的sessionStorage
  sessionStorage.removeItem('authorization')
  sessionStorage.removeItem('user')
  sessionStorage.removeItem('menus')
  sessionStorage.removeItem('rawMenus')
  // 清除所有 sessionStorage
  sessionStorage.clear()
  router.replace({
    path: '/'
  })
}

Number.prototype.toFixedPlus = function (num) {
  // 严格限定只支持 \d 正整型数字
  num = /^\d+$/.test(num) ? Number(num) : 0;
  // 我们需要操作的数字，它只会是正数，符号是不会进入参加计算的
  let valStr = Number(this).toString();
  // 小数点的位置，也时也是整数部分与符号部分的长度
  let pointIndex = valStr.indexOf('.');
  // 获取数字的最后一位
  function _lastNumber(vStr) {
    return Number(Number(vStr).toString().substr(-1, 1));
  }
  // 进位，虽然这个过程可能会有误差，但是是接近原数如0.000999999998之类的，可以用toFixed变成0.001了
  function _carry(vStr) {
    return ((Number(vStr) + Math.pow(10, -num)).toFixed(num)).toString();
  }
  // 补0, vStr数字, zoreN补0个数, point是否需要'.'
  function _supplyZore(vStr, zoreN, point = '') {
    return vStr + point + new Array(zoreN + 1).join('0');
  }
  if (pointIndex >= 0) {
    // 最后需要变成的长度，比如1.0015.toFixedPlus(3),那么最后变在 1(整数) + 1(小数点) + 3(保留小数的长度)
    let newValLen = pointIndex + 1 + num;
    // 不考虑进位时，返回的结果，即前半部分，比如1.0015的前半部分是0.001
    let preStr = valStr.substr(0, newValLen);
    // 用来判断是否需进位的后半部分，如1.0015的后半部分是5
    let nextStr = valStr.substr(newValLen);
    // 后半部分的第一位数字
    let nextFirstN = nextStr ? Number(nextStr.substr(0, 1)) : 0;
    switch (true) {
      // 四舍去
      case nextFirstN <= 4:
        valStr = preStr;
        break;
        // 五判断各类情况再处理
      case nextFirstN === 5:
        if (/^5[0]*$/.test(nextStr)) {
          // preStr可能会是 1. 这种形式，除了先转成1，再取得前半部最后一个数字
          let preLastN = _lastNumber(preStr);
          if (preLastN % 2 === 1) {
            valStr = _carry(preStr);
          } else {
            valStr = preStr;
          }
        } else {
          valStr = _carry(preStr);
        }
        break;
        // 六进位
      case nextFirstN >= 6:
        valStr = _carry(preStr);
        break;
    }
    // 如果有小数变成无小数，去除多余的小数点
    if (num === 0) {
      valStr = valStr.replace('.', '');
    } else {
      // 小数时，长度差额，补0个数
      let lessZore = newValLen - valStr.length;
      if (lessZore >= 1) {
        valStr = _supplyZore(valStr, lessZore);
      }
    }
  } else {
    // 没有小数点时补0
    if (num >= 1) {
      valStr = _supplyZore(valStr, num, '.');
    }
  }
  return valStr;
}
/*
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
*/
/*
定义全局函数
 */
// 全局loading
let loadingInstance = null
Vue.prototype.setLoading = function (_display) {
  if (_display === 'show') {
    loadingInstance = this.$loading({
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
      customClass: 'app-loading'
    })
    /*
     * loading对象的zIndex样式，是通过计算获得到的，无法通过样式进行修改，也没有对应的属性或方法进行修改
     * 应用中的需求是，要让loading覆盖在所有的页面之上，针对loading的特点，添加了一个自定义的className（app-loading），
     * 通过这个名称，获取loading元素，然后设置zIndex的值为10000，可以满足覆盖在所有元素之上的需求
     */
    let loadingDom = document.getElementsByClassName('app-loading')
    loadingDom[0].style.zIndex = 10000
  } else {
    loadingInstance.close()
  }
}
// 定义服务器访问的根地址
// const ApiRoot = 'http://localhost:5000/'
// 通过在public目录下，建立一个static/js/config.js文件，定义可配置的ip
const ApiRoot = window.g.baseUrl
// 定义访问服务器Api的根路径
Vue.prototype.$apiroot = ApiRoot
// 加载各个模块中的api
Vue.prototype.$apis = baseApis
/*
sessionStorage的使用
添加一个sessionStorage
sessionStorage.setItem('token', this.userName)
在任意页面任意方法中获取
sessionStorage.getItem("token")
退出登录时，删除当前的
sessionStorage.removeItem("token")
//清除全部
sessionStorage.clear()
*/

/* 定义全局的ajax方法 */
/*
_contentType 是要区分JSON方式提交，还是form方式提交，默认是JSON方式提交。如果是form方式提交，需要通过$qs进行格式化
headers中加入JWT验证字符串
*/
Vue.prototype.post = function (_url, _params, _cb, _contentType, _loadingcb) {
  let _this = this
  if (_loadingcb == null || _loadingcb === undefined) {
    _this.setLoading('show')
  } else {
    _loadingcb('show')
  }
  // form方式提交时，需要将数据通过qs格式化
  if (_contentType && _contentType === 'form') {
    _params = _this.$qs.stringify(_params)
  }
  _this.$http.post(_url, _params, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': 'bearer ' + sessionStorage.getItem('authorization'),
      'account': sessionStorage.getItem('account') == null ? '' : sessionStorage.getItem('account')
    }
  }).then(function (res) {
    // 返回logout，重新登录
    if (res.data && res.data.status && res.data.status === 'logout') {
      if (_loadingcb == null || _loadingcb === undefined) {
        _this.setLoading('hide')
      } else {
        _loadingcb('hide')
      }

      _this.logout()
      return
    }
    if (_loadingcb == null || _loadingcb === undefined) {
      _this.setLoading('hide')
    } else {
      _loadingcb('hide')
    }
    _cb(res)
  }).catch(err => {
    console.log(err)
    if (err.response.status === 401) {
      _this.$message.error('由于您长时间未操作系统，出于安全因素，请您重新登录')
      _this.logout()
      _this.setLoading('hide')
    }
  })
}

Vue.prototype.get = function (_url, _params, _cb, _loadingcb) {
  let _this = this
  if (_loadingcb == null || _loadingcb === undefined) {
    _this.setLoading('show')
  } else {
    _loadingcb('show')
  }
  _this.$http.get(_url, {
    params: _params,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': 'bearer ' + sessionStorage.getItem('authorization'),
      'account': sessionStorage.getItem('account') == null ? '' : sessionStorage.getItem('account')
    }
  }).then(function (res) {
    // 返回logout，表示重新登录
    if (res.data && res.data.status && res.data.status === 'logout') {
      console.log('post filter logout')
      if (_loadingcb == null || _loadingcb === undefined) {
        _this.setLoading('hide')
      } else {
        _loadingcb('hide')
      }
      _this.logout()
      return
    }
    _this.setLoading('hide')
    _cb(res)
  }).catch(err => {
    console.log(err)
    if (err.response.status === 401) {
      _this.logout()
      if (_loadingcb == null || _loadingcb === undefined) {
        _this.setLoading('hide')
      } else {
        _loadingcb('hide')
      }
    }
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')